module.exports = __webpack_public_path__ + "static/media/raplayer_801.6e5473c2.ico";